export default __webpack_public_path__ + "da32165385e8726c4e0de3bcebab8449.svg";